export const typeDefs = `
  input MarkAnnouncementsReadInputMutation = {
    ids: [String!]!
  }
`;
